import { useEffect, useState } from "react";
import deleteIcon from "@assets/icons/icon-bin.svg";
import Button from "@components/Button/Button";
import { useWindowSize } from "@hooks/useWindowSize";
import {
  RecentSearchObject,
  SearchRecentResultsProps,
} from "@routes/Search/utils/types";
import useRecentSearchStore from "@store/useRecentSearchStore";
import { cn } from "@util/helpers";

export default function SearchRecentResults({
  setSelectedKeyword,
  searchQuery,
}: SearchRecentResultsProps): React.ReactElement {
  const [query, setQueryList] = useState<RecentSearchObject[]>(searchQuery);
  const deleteAllSearchQuery = useRecentSearchStore(
    (state) => state.deleteAllSearchQuery
  );
  const { isScreenLG } = useWindowSize();

  useEffect(() => {
    const size = isScreenLG ? 10 : 5;
    const querySlice = searchQuery.slice(0, size);

    setQueryList(querySlice);
  }, [isScreenLG, searchQuery]);

  const handleDeleteAllSearch = () => {
    deleteAllSearchQuery();
  };

  return (
    <div data-testid="search-recent-search-component" className="mt-6 md:mt-18">
      <div className="mb-6 flex w-full justify-between border-b border-gray-175 py-2">
        <div className="flex items-center">
          <p className="font-poppins text-4xs font-semibold uppercase tracking-5 md:text-xs">
            SEARCH HISTORY
          </p>
        </div>

        <Button onClick={handleDeleteAllSearch} className={"border-none"}>
          <img
            src={deleteIcon}
            width={24}
            height={24}
            alt="delete"
            className="mr-2"
          />
        </Button>
      </div>

      <div className={cn("flex w-full flex-wrap")}>
        {query.map((search) => {
          return (
            <Button
              key={search.query}
              onClick={() => {
                setSelectedKeyword(search.query || "");
              }}
              className={cn(
                "mb-4 mr-4 w-max rounded-[4px] px-4 py-2 font-medium transition-all duration-300 md:text-lg"
              )}
            >
              {search.query}
            </Button>
          );
        })}
      </div>
    </div>
  );
}
